import SystemLabel from "../system/SystemLabel/SystemLabel";
import React from 'react';

export const validationTypes = [
    { label: <SystemLabel name="None" />, value: "none" },
    { label: <SystemLabel name="Email" />, value: "email" },
    { label: <SystemLabel name="Phone" />, value: "phone" },
    { label: <SystemLabel name="Numeric" />, value: "numeric" },
]